import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import TimelineItem from 'antd/lib/timeline/TimelineItem';
import { TrackPoint } from '../../../common/api/spidertracks-sdk/types/TrackData';
import { formatDisplayTime, formatDurationInMillis } from '../utils/timeUtils';
import { GreyDot } from './GreyDot';

export interface FlightLogsLoadingTimeLineItemProps {
  firstPoint: TrackPoint;
  lastPoint: TrackPoint;
  dateFormat: string;
  timeFormat: string;
  timezone: string;
  isActive: boolean;
}
export const FlightLogsLoadingTimeLineItem: React.FC<FlightLogsLoadingTimeLineItemProps> = ({
  firstPoint,
  lastPoint,
  dateFormat,
  timeFormat,
  timezone,
  isActive
}) => {
  const dateTimeFormat = `${dateFormat} ${timeFormat}`;
  return (
    <>
      <TimelineItem
        key={firstPoint.timestamp}
        dot={isActive ? undefined : <GreyDot />}
        color={isActive ? 'grey' : undefined}
      >
        <Row style={{ marginLeft: '5px' }}>
          <Col span={6} style={{ textAlign: 'left' }}>
            <span>
              {formatDisplayTime(firstPoint.timestamp, timezone, dateTimeFormat, timeFormat)}
            </span>
          </Col>
          <Col span={13} style={{ textAlign: 'left' }}>
            <span> First Point</span>
          </Col>
        </Row>
      </TimelineItem>
      <TimelineItem
        key={`${firstPoint.timestamp}-loading`}
        dot={<LoadingOutlined spin style={{ fontSize: '12px' }} />}
      >
        <Row style={{ marginLeft: '5px' }}>
          <Col offset={6} span={13} style={{ textAlign: 'left' }}>
            <span>Loading...</span>
          </Col>
        </Row>
      </TimelineItem>
      {!isActive && (
        <TimelineItem key={lastPoint.timestamp} dot={<GreyDot />}>
          <Row style={{ marginLeft: '5px' }}>
            <Col span={6} style={{ textAlign: 'left' }}>
              <span>
                {formatDisplayTime(lastPoint.timestamp, timezone, dateTimeFormat, timeFormat)}
              </span>
            </Col>
            <Col span={13} style={{ textAlign: 'left' }}>
              <span> Last Point</span>
            </Col>
            <Col span={5} style={{ textAlign: 'end' }}>
              <span style={{ color: '#8C8C8C', fontSize: 'small' }}>
                {formatDurationInMillis(lastPoint.timestamp - firstPoint.timestamp)}
              </span>
            </Col>
          </Row>
        </TimelineItem>
      )}
    </>
  );
};
